import React from 'react';
import styled from 'styled-components';
import { AttachmentApi } from '../../api/attachment.api';
import { useComponentDidMount } from '../../utils/hooks';
import { Loader } from '../atoms';
import { PreviewModalAttachmentLabel } from './PreviewModalAttachmentLabel';

const BaseStyledDiv = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonStyledDiv = styled.div`
  width: 100%;
  text-align: right;
  margin-bottom: 10px;
  cursor: pointer;
`;

const ButtonStyledImg = styled.img`
  margin-right: 10px;
`;

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 296px;
  width: 296px;
`;

const StyledSpan = styled.span`
  color: #bf0000;
`;

const StyledImg = styled.img`
  max-height: calc(80vh - env(safe-area-inset-bottom));
  max-width: 100vw;
  object-fit: contain;
  margin-left: auto;
  margin-right: auto;
`;

interface Props {
  attachment: {
    fileName: string;
    fileId?: string;
    disabled: boolean;
  };
  isError: boolean;
  isVisibleImage: boolean;
  isWide: boolean;
  onClickClose: () => void;
  onError: () => void;
  onLoad: () => void;
}

export const PreviewModalImage = (props: Props) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [img, setImg] = React.useState<string>('');
  const {
    attachment,
    isError,
    isVisibleImage,
    isWide,
    onClickClose,
    onError,
    onLoad,
  } = props;
  const disabled = attachment ? attachment.disabled : false;
  const fileId = attachment && attachment.fileId ? attachment.fileId : '';
  const fileName = attachment && attachment.fileName ? attachment.fileName : '';

  const getImg = async () => {
    setIsLoading(true);
    if (fileId) {
      const data = await AttachmentApi.getAttachment(fileId, fileName);
      setImg(data);
    }
    setIsLoading(false);
  };

  useComponentDidMount(() => {
    getImg();
  });

  return (
    <BaseStyledDiv>
      <ButtonStyledDiv onClick={onClickClose}>
        <ButtonStyledImg
          alt="close button"
          src="/images/close_button_white.png"
        />
      </ButtonStyledDiv>
      <StyledDiv
        style={{
          display: !isVisibleImage ? 'flex' : 'none',
        }}
      >
        {disabled ? (
          <StyledSpan>保存期間を超えたためダウンロードできません</StyledSpan>
        ) : isError ? (
          <StyledSpan>画像が見つかりませんでした</StyledSpan>
        ) : isLoading ? (
          <Loader />
        ) : null}
      </StyledDiv>
      {fileId && !isLoading ? (
        <div>
          <StyledImg
            src={img}
            alt={fileName}
            draggable={false}
            style={{
              // Immediately indicate image by toggling display property
              display: isVisibleImage ? 'flex' : 'none',
            }}
            onLoad={onLoad}
            onError={onError}
          />
        </div>
      ) : null}
      <PreviewModalAttachmentLabel
        attachment={attachment}
        disabled={!isVisibleImage}
        isWide={isWide}
      />
    </BaseStyledDiv>
  );
};
